import { objToQs } from "../Utils";

import Call from '../Call';

const Domains = {
    get(filters) {
        return Call(`lpDomains?${objToQs(filters)}`);
    },
    update(id, entity) {
        return Call(`lpDomains/${id}`,'PUT', entity);
    },
    save(entity) {
        return Call('lpDomains','POST', entity);
    },
    remove(id) {
        return Call(`lpDomains/${id}`,'DELETE');
    },
    distinct(field) {
        return Call(`lpDomains/distinct/${field}`);
    },
    types() {
        return Call(`lpDomains/types`);
    },
};

export default Domains;



// WEBPACK FOOTER //
// ./src/services/API/components/Domains.js